import { ProductCategoryCode, UserProductType } from 'pleinchamp-api-client';
import React, { ComponentPropsWithRef, FC, forwardRef, PropsWithChildren } from 'react';
import Truncate from 'react-truncate';
import { PrimaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { Text } from '@components/Text/Text.component';
import { PlcAnchor } from '@layout/components/PlcAnchor/PlcAnchor.component';
import { getStockDetailRouteParams } from '@stocks/business/Stocks.utils';
import { StockIsFavorite } from '@stocks/components/StockIsFavorite/StockIsFavorite.component';
import classnames from 'classnames';
import styles from './StockDetails.module.scss';

export type StockDetailsWrapperProps = ComponentPropsWithRef<'div'> & {
  title: string;
  cardType: 'full' | 'small';
  productType: UserProductType;
};

export const StockDetailsWrapper: FC<PropsWithChildren<StockDetailsWrapperProps>> = forwardRef(
  ({ title, children, className, cardType, productType, ...rest }, stockDetailRef) => {
    const headerClassName = classnames(styles.wrapperHeader);
    const contentClassName = classnames('flex', cardType === 'small' ? 'plc-my-s' : 'plc-my-m');
    const market = productType.products[0]?.market ?? productType?.marketReference;

    return (
      <div ref={stockDetailRef} {...rest}>
        <header className={headerClassName}>
          <StockIsFavorite
            market={productType.productCategoryCode === ProductCategoryCode.Cattle ? market : undefined}
            productType={productType}
          />
          <Text className="width-100 plc-pl-s" flavour="midnight-green" tag="p" variant="new-bold">
            <Truncate key={title} lines={cardType === 'full' ? 1 : 2} width={220}>
              {title}
            </Truncate>
          </Text>
        </header>
        <main className={contentClassName}>{children}</main>
        <footer className={styles.footerButton}>
          <PlcAnchor linkProps={getStockDetailRouteParams(productType, market)}>
            <PrimaryButton isLightGreen isSmall textProps={{ i18nKey: 'stocks.home.button.favorites.details' }} />
          </PlcAnchor>
        </footer>
      </div>
    );
  }
);
